
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
const app = namespace("app");

@Component({})
export default class RepeatOrderDialog extends Vue {
  @Prop({ type: Object, default: () => {} })
  checkData: any;
  @Prop({ type: String, default: "service" }) // order-服务 check-检测
  orderType: any;
  @Prop({ type: String, default: "1" }) // 1维保 2洗车 3零售
  serviceType: any;
  @app.State btnLoading;
  dayjs = dayjs;
  show: boolean = false;
  serviceTypeTextMap: any = {
    "1": t("v210831.maintenance"),
    "2": t("v210831.car-wash"),
    "3": t("v210831.retail")
  };
  get orderTypeDesc() {
    if (this.orderType === "check") {
      return t("v210831.testing");
    } else {
      return this.serviceTypeTextMap[this.serviceType];
    }
  }
  handleConfirmClick() {
    this.$emit("confirm");
  }
  handleLinkTodayOrderView() {
    const pathPerfix = this.orderType === "check" ? "/test/view/" : "/service/view/";
    window.open(this.$router.resolve(`${pathPerfix}${this.checkData.orderNo}`).href);
  }
  @Watch("checkData", { deep: true })
  checkDataChange(data) {
    if (data?.orderTime) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}
